<template>
  <div>
    <h1>{{title}}</h1>
    <div>
      <transition-group name="fade" class="image-grid" :style="getGridStyle">
        <template v-for="item in items">
          <div :key="item[keyID]" class="grid-item">
            <div class="image-wrap">
              <div :style="getItemStyle(item)"></div>
            </div>
            <div class="meta" v-if="loggedIn">
              <p>{{item[keyTitle]}}</p>
              <p style="font-size:1rem;">Tags: {{item.tags}}</p>
              <ux-modal-button :asset="item"></ux-modal-button>
            </div>
          </div>
        </template>
      </transition-group>
    </div>
  </div>
</template>

<script>
import UxModalButton from "./UxModalButton";
export default {
  components: { UxModalButton },
  props: {
    items: {
      default: function() {
        return [];
      }
    },
    keyID: {
      default: "id"
    },
    keyTitle: {
      default: "title"
    },
    keyURL: {
      default: "url"
    },
    title: {
      default: ""
    },
    ratio: {
      default: function() {
        return { w: 16, h: 9 };
      }
    },
    columns: {
      default: 4
    }
  },
  methods: {
    getItemStyle(el) {
      let bg = el[this.keyURL];
      return {
        backgroundImage: "url(" + bg + ")",
        backgroundSize: "contain",
        paddingTop: "90%",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
      };
    },
    deleteItem(el) {
      this.$store.dispatch("deleteItem", el);
    }
  },
  computed: {
    loggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    getGridStyle() {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(130px,1fr))",
        gridGap: "5px"
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.image-wrap {
  padding: 10px;
  margin: 10px 0;
}
.grid-item {
  background: #111;
  .meta {
    background: black;
    padding: 10px;
    p {
      margin: 0;
    }
  }
}
</style>

